import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST } from '../../../redux/middleware/types'
import integrationRequest from '../../../services/api/integrationRequest'
import reconciliationEndpoints from '../api/reconciliationEndpoints'
import reconciliationQueryKeys from '../queries/reconciliationQueryKeys'
import {
  Match,
  ReconciliationApprovalItem,
  ReconciliationApproveResponse,
  ReconciliationRevokeResponse
} from '../types'

// Server rejects (400, nothing processed) a batch larger than this.
export const MAX_APPROVALS_PER_REQUEST = 500

export const getReconciliationMatches = async ({
  queryKey: [{ groupCompanyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof reconciliationQueryKeys)['list']>>): Promise<Match[]> => {
  if (!groupCompanyId) return []
  return integrationRequest<Match[]>({
    method: GET,
    url: reconciliationEndpoints.list(groupCompanyId),
    signal
  })
}

// Accept one or more entries. Partial success: the response has one result per item,
// in request order. Idempotent — replaying an identical batch is harmless.
export const approveReconciliationMatches = async (
  groupCompanyId: string,
  approvals: ReconciliationApprovalItem[]
): Promise<ReconciliationApproveResponse> =>
  integrationRequest<ReconciliationApproveResponse>({
    method: POST,
    url: reconciliationEndpoints.approvals(groupCompanyId),
    data: { approvals }
  })

// Un-accept previously accepted entries by approvalId. Per-item revoked | not_found.
export const revokeReconciliationApprovals = async (
  groupCompanyId: string,
  approvalIds: number[]
): Promise<ReconciliationRevokeResponse> =>
  integrationRequest<ReconciliationRevokeResponse>({
    method: DELETE,
    url: reconciliationEndpoints.approvals(groupCompanyId),
    data: { approvalIds }
  })
